import { useEffect, useMemo, useState } from "react"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { PanelLoader, useGetCrumbs, useUIStateActions } from "../../../../../features/ui"
import { Customer, HoardOrder, useCustomerLoaders } from "../../../../sales"
import { TableName } from "../../../../../tables"
import { describeHelpers, useDescribeHooks } from "../../../../../features/data-types"
import { EmitFinancialDeliveryOrderForm } from "./emitFinancialDeliveryOrderForm"
import { Lot, useLotLoaders } from "../../../../products"

export const EmitFinancialDeliveryOrderFormLoader = () => {
    const { tableName, dataType } = useRoutesHooks().parseUrl()
    const hoard = dataType! as HoardOrder
    
    const [ready, setReady] = useState(false)
    const [customer, setCustomer] = useState<Customer>()
    const [lots, setLots] = useState<Lot[]>([])
    
    const { describeCode } = describeHelpers
    const { describe } = useDescribeHooks()
    
    const customerLoaders = useCustomerLoaders()
    const lotLoaders = useLotLoaders()

    const { setDisableBranchSelector } = useUIStateActions()
    
    const load = async () => {
        const { loadCustomer } = customerLoaders()
        const loadedCustomer = await loadCustomer(hoard.customerId)
        setCustomer(loadedCustomer)
        const { loadAllLots, loadLots } = lotLoaders()
        const loadedLots = hoard.items.length > 0 ?
            await loadLots(hoard.items.map(item => item.productId)) :
            await loadAllLots()
        setLots(loadedLots)
    }

    useEffect(() => {
        setDisableBranchSelector(true)
        load().then(() => setReady(true))
        return () => {
            setDisableBranchSelector(false)
        }
    }, [])

    const title = useMemo(() => `Emitir Entrega de ${describe(TableName.HOARD_ORDERS, hoard)}`, [hoard])
    const crumbs = useGetCrumbs(
        'Acopios',
        RoutePath.HOARDS,
        describeCode(hoard),
        hoard.id,
        'Emitir Entrega'
    )

    return (
        <PanelLoader
            title={title}
            crumbs={crumbs}
            ready={ready}
            wide
        >
            <EmitFinancialDeliveryOrderForm
                table={tableName!}
                hoard={hoard}
                customer={customer!}
                lots={lots}
            />
        </PanelLoader>
    )
}
